import { render } from "./CustomerLogin.vue?vue&type=template&id=05bb309a"
import script from "./CustomerLogin.vue?vue&type=script&lang=js"
export * from "./CustomerLogin.vue?vue&type=script&lang=js"

import "./CustomerLogin.vue?vue&type=style&index=0&id=05bb309a&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__